<div class="mi-genral-skeleton container " id="mi-genral-skeleton "><!--id???-->

    <div class="row justify-content-center">
        <div class="  col-12 mi-panel-wrraper standart">
            <div class="mi-panel-content">
                <div class="mi-white-panel with-shadow">

                    <div>
                        <span class="   d-block mc-mt-3">
                            <mc-bar-skeleton [widthBar]="'40%'" [heightBar]="'1.2rem'"></mc-bar-skeleton>
                        </span>
                        <span class="   d-block mc-mt-2">
                            <mc-bar-skeleton [widthBar]="'55%'" [heightBar]="'1.2rem'"></mc-bar-skeleton>

                        </span>
                        <div class="mc-border-bottom    d-block mc-mt-3"></div>
                        <div class="row">
                            <span class="col-xs-12 col-md-4">
                                <mc-bar-skeleton class="   d-block mc-mt-5 mc-mb-3" [widthBar]="'80%'"
                                    [heightBar]="'1.2rem'"></mc-bar-skeleton> </span>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-md-4">
                                <mc-bar-skeleton class="   d-block mc-mt-3" [widthBar]="'40%'"
                                    [heightBar]="'1rem'"></mc-bar-skeleton>

                                <mc-bar-skeleton class="   d-block mc-mt-2" [widthBar]="'100%'"
                                    [heightBar]="'3rem'"></mc-bar-skeleton>
                            </div>
                            <div class="col-xs-12 col-md-4">
                                <mc-bar-skeleton class="   d-block mc-mt-3" [widthBar]="'40%'"
                                    [heightBar]="'1rem'"></mc-bar-skeleton>

                                <mc-bar-skeleton class="   d-block mc-mt-2" [widthBar]="'100%'"
                                    [heightBar]="'3rem'"></mc-bar-skeleton>
                            </div>
                        </div>
                        <div class="row">
                            <span class="col-xs-12 col-md-4">
                                <mc-bar-skeleton class="   d-block mc-mt-5 mc-mb-3" [widthBar]="'80%'"
                                    [heightBar]="'1.2rem'"></mc-bar-skeleton>
                            </span>
                        </div>
                        <div class="row">

                            <div class="col-xs-12 col-md-4">
                                <mc-bar-skeleton class="   d-block mc-mt-3" [widthBar]="'40%'"
                                    [heightBar]="'1rem'"></mc-bar-skeleton>

                                <mc-bar-skeleton class="   d-block mc-mt-2" [widthBar]="'100%'"
                                    [heightBar]="'3rem'"></mc-bar-skeleton>
                            </div>

                            <div class="col-xs-12 col-md-4">
                                <mc-bar-skeleton class="   d-block mc-mt-3" [widthBar]="'40%'"
                                    [heightBar]="'1rem'"></mc-bar-skeleton>

                                <mc-bar-skeleton class="   d-block mc-mt-2" [widthBar]="'100%'"
                                    [heightBar]="'3rem'"></mc-bar-skeleton>
                            </div>
                            <div class="col-xs-12 col-md-4 d-none d-md-flex">
                                <mc-bar-skeleton class="   d-block mc-mt-3" [widthBar]="'40%'"
                                    [heightBar]="'1rem'"></mc-bar-skeleton>

                                <mc-bar-skeleton class="   d-block mc-mt-2" [widthBar]="'100%'"
                                    [heightBar]="'3rem'"></mc-bar-skeleton>
                            </div>
                            <div class="col-xs-12 col-md-4 d-none d-md-flex">
                                <mc-bar-skeleton class="   d-block mc-mt-3" [widthBar]="'40%'"
                                    [heightBar]="'1rem'"></mc-bar-skeleton>

                                <mc-bar-skeleton class="   d-block mc-mt-2" [widthBar]="'100%'"
                                    [heightBar]="'3rem'"></mc-bar-skeleton>
                            </div>
                            <div class="col-xs-12 col-md-4 d-none d-md-flex">
                                <mc-bar-skeleton class="   d-block mc-mt-3" [widthBar]="'40%'"
                                    [heightBar]="'1rem'"></mc-bar-skeleton>

                                <mc-bar-skeleton class="   d-block mc-mt-2" [widthBar]="'100%'"
                                    [heightBar]="'3rem'"></mc-bar-skeleton>
                            </div>
                            <div class="col-xs-12 col-md-4 d-none d-md-flex">
                                <mc-bar-skeleton class="   d-block mc-mt-3" [widthBar]="'40%'"
                                    [heightBar]="'1rem'"></mc-bar-skeleton>

                                <mc-bar-skeleton class="   d-block mc-mt-2" [widthBar]="'100%'"
                                    [heightBar]="'3rem'"></mc-bar-skeleton>
                            </div>
                            <div class="col-xs-12 col-md-4 d-none d-md-flex">
                                <mc-bar-skeleton class="   d-block mc-mt-3" [widthBar]="'40%'"
                                    [heightBar]="'1rem'"></mc-bar-skeleton>

                                <mc-bar-skeleton class="   d-block mc-mt-2" [widthBar]="'100%'"
                                    [heightBar]="'3rem'"></mc-bar-skeleton>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>



    </div>